import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const RectangleHorizontal: IconNode = [
  'svg',
  defaultAttributes,
  [['rect', { x: '2', y: '6', width: '20', height: '12', rx: '2' }]],
];

export default RectangleHorizontal;
